import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledEmpty} from "@/shared/StyledComponents";
import {Action, ACTION_SPACE, ActionBase} from "@/shared/types";
import {Pages, PracticeData} from "@/libwyze-shared/types";
import {EditDeviceHelper} from "./EditDeviceHelper";
import {BaseListFragment} from "../../shared/BaseListFragment";
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {PD_LG, PD_MD, PD_XLG2} from "../../shared/dimens";
import {AddOutlined, MoreVertOutlined} from "@mui/icons-material";
import {PathComponent} from "../../shared";
import {Device, Devices} from "@/checkin-common/types";
import defaultDevicesImage from "./res/images/default_devices.png";
import {BaseApp, DIALOG_FLAG_SHOW_CLOSE, DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN} from "../../shared/BaseApp";
import {CheckinPlayerFragment} from "@/checkin-shared/checkin/CheckinPlayerPreviewFragment";

export type DevicesFragmentProps = PageFragmentProps & {}

type DevicesFragmentState = PageFragmentState & {}

export class DevicesFragment extends BaseListFragment<Device, Devices, DevicesFragmentProps, DevicesFragmentState> {

  static nestedPaths(): PathComponent[] {
    return [];
  }

  private readonly actions: ActionBase[] = [
    ACTION_SPACE,
    new Action("Link Device", () => {
      EditDeviceHelper.addDevice();
    }, AddOutlined)
      .setVariant("contained"),
  ];

  private readonly popoverActions: ActionBase[] = [
    new Action("Preview", (e) => {
      BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN},
        () => <CheckinPlayerFragment
          practicePage={Pages.getInstance().getListItem(PracticeData.provider().practiceId)}/>);
    }),
    new Action("Delete", (e) => {

    }).makeDestructive(),
  ]

  constructor(props: DevicesFragmentProps, context: any) {
    super(props, context, new Devices(PracticeData.provider().practiceId));
  }

  protected getTitle(): string | null | undefined {
    return "Devices";
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx(this.actions);
  }

  renderContent(): ReactElement {
    const items = this.loader.getListItems();
    if (!(items?.length > 0)) {
      return <StyledEmpty emptyConfig={{
        title: "Link a device",
        text: "Set up a check-in device by linking it to your practice.",
        iconUrl: "/images/landing-page.svg",
        action: new Action("Link a device", () => EditDeviceHelper.addDevice()),
      }}/>;
    }
    return <div style={{width: "100%", padding: PD_LG}}>
      <Grid container>
        {items.map(item => <Grid xs={12} sm={6} md={4} lg={3}>
          <Button
            onClick={() => EditDeviceHelper.editDevice(item)}
            style={{position: "relative", width: "100%", height: "100%"}}>
            <StyledBoxColumn style={{width: "100%", flexGrow: 1, padding: PD_XLG2}}>
              <img src={defaultDevicesImage}
                   style={{width: "100%", aspectRatio: 1, objectFit: "contain"}}/>
              <Typography>{item.title}</Typography>
            </StyledBoxColumn>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                BaseApp.CONTEXT.showActionsListPopover(e.target as HTMLElement, null, this.popoverActions);
              }}
              style={{position: "absolute", top: PD_MD, right: PD_MD}}>
              <MoreVertOutlined/>
            </IconButton>
          </Button>
        </Grid>)}
      </Grid>
    </div>;
  }
}